import styles from "./toast.module.scss";
import { useEffect, useState } from "react";
import { GoAIcon } from "@abgov/react-components";

const { container, label, spacer } = styles;

export interface IToast {
  type: "success" | "error" | "warning" | "info";
  message: string;
  callback?: () => void;
}
export const TOAST_EVENT = "toast";
export const publishToast = (toast: IToast) => {
  const event = new CustomEvent(TOAST_EVENT, { detail: toast });
  document.dispatchEvent(event);
};
export const failedToPerform = (actionPerformed: string, reason: string) => {
  return `Failed to ${actionPerformed}. ${reason}`;
};

interface IProps {}
const Toast: React.FC<IProps> = () => {
  const [toast, setToast] = useState<IToast>({} as IToast);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  let timeout: NodeJS.Timeout;
  const processToastEvent = (event: CustomEvent) => {
    const _toast = event.detail as IToast;
    if (_toast) {
      setToast(_toast);
      setIsVisible(true);
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        setIsVisible(false);
      }, 8000);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.addEventListener(TOAST_EVENT, processToastEvent as any);

    return () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      document.removeEventListener(TOAST_EVENT, processToastEvent as any);
    };
    // eslint-disable-next-line
  }, []);

  function showRetry() {
    return toast.callback;
  }

  function retry() {
    clearTimeout(timeout);
    setIsVisible(false);

    if (toast.callback) {
      toast.callback();
    }
  }
  return !isVisible ? null : (
    <div className={`${container} ${styles[toast.type]}`}>
      {toast.type === "success" && (
        <GoAIcon type="checkmark-circle" theme="outline" size="large"></GoAIcon>
      )}
      {toast.type === "error" && (
        <GoAIcon type="close-circle" theme="outline" size="large"></GoAIcon>
      )}
      {toast.type === "warning" && (
        <GoAIcon type="warning" theme="outline" size="large"></GoAIcon>
      )}
      <div className={label}>{toast.message}</div>
      {showRetry() && <div className={spacer}></div>}
      {showRetry() && (
        <a onClick={retry} href="#/">
          Retry
        </a>
      )}
    </div>
  );
};

export default Toast;
